const appInfo = {
    title: 'derGefahrensucher'
};
export default appInfo;

